<template>
  <div class="kimmuJisseki">
    <el-card id="kimmuCard">
      <el-form ref="form" :model="form" :rules="rules" label-width="85px" v-loading="loading" size="medium">
        <el-form-item v-if="isRomu" label="スタッフ名" prop="shainShimei">
          <span id="shainShimei">{{form.shainShimei}}</span>
        </el-form-item>
        <el-form-item label="勤務日" prop="kimmuBi">
          <el-button type="default" @click="onChange(-1)" size="medium" icon="el-icon-arrow-left" class="shiftButton"></el-button>
          <el-date-picker v-model="form.kimmuBi" value-format="yyyy-MM-dd" @change="onChange" :clearable="false" ></el-date-picker>
          <el-button type="default" @click="onChange(1)" size="medium" icon="el-icon-arrow-right" class="shiftButton"></el-button>
        </el-form-item>
        <el-form-item label="勤務区分" prop="kimmuKubun">
          <select v-model="form.kimmuKubun" id="kimmuKubunSelect" :disabled="!canEdit" @change="onChangeKubun">
            <option v-for="kubun in kimmuKubuns" :key="kubun.value" :value="kubun.value">{{kubun.label}}</option>
          </select>
          <!--
          <el-select v-model="form.kimmuKubun" :disabled="!canEdit">
            <el-option v-for="kubun in kimmuKubuns" :key="kubun.value" :label="kubun.label" :value="kubun.value"></el-option>
          </el-select>
          -->
          <div>
          <select v-show="isJikanYukyu" v-model="form.yukyuJikanKubun" id="yukyuJikanKubunSelect" :disabled="!canEdit">
            <option v-for="kubun in yukyuJikanKubuns" :key="kubun.value" :value="kubun.value">{{kubun.label}}</option>
          </select>
          <select v-show="isJikanYukyu" v-model="form.yukyuJikansu" id="yukyuJikanSelect" :disabled="!canEdit">
            <option v-for="jikan in yukyuJikans" :key="jikan.value" :value="jikan.value">{{jikan.label}}</option>
          </select>
          </div>
          <span v-show="isJikanYukyu">※昼休憩を跨ぐ場合は休憩を除く</span>
        </el-form-item>
        <el-form-item label="始業時刻" prop="shigyoJikoku" v-show="!isHoliday" :error="errors.shigyoJikoku" >
          <el-input v-model="form.shigyoJikoku" :disabled="!canEdit || isHoliday" type="time" @change="onChangeShigyoJikoku"></el-input>
          <el-input v-model="form.kimmuJikan" type="hidden"></el-input>
        </el-form-item>
        <el-form-item label="終業時刻" prop="shugyoJikoku" v-show="!isHoliday" :error="errors.shugyoJikoku">
          <el-input v-model="form.shugyoJikoku" :disabled="!canEdit || isHoliday" type="time" @change="onChangeShugyoJikoku"></el-input>
          <span id="hyoji" class="sub-label">({{form.shugyoJikokuHyoji}})</span>
        </el-form-item>
        <el-form-item label="昼食時間" prop="chushokuJikan" v-show="!isHoliday" :error="errors.chushokuJikan">
          <el-input v-model="form.chushokuJikan" :disabled="!canEdit || isHoliday" type="time"></el-input>
        </el-form-item>
        <el-form-item label="休憩時間" prop="kyukeiJikan" v-show="!isHoliday" :error="errors.kyukeiJikan">
          <el-input v-model="form.kyukeiJikan" :disabled="!canEdit || isHoliday" type="time" @change="onChangeKyuKeiJikan"></el-input>
          <span class="sub-label">(深夜休憩含む)</span>
        </el-form-item>
        <el-form-item label="深夜休憩" prop="shinyaKyukeiJikan" v-show="!isHoliday" :error="errors.shinyaKyukeiJikan">
          <el-input v-model="form.shinyaKyukeiJikan" :disabled="!canEdit || isHoliday" type="time" @change="onChangeShinyaKyuKeiJikan"></el-input>
          <el-input v-model="form.shinyaKyukeiJikanKomi" :disabled="!canEdit || isHoliday" type="hidden"></el-input>
        </el-form-item>
        <el-form-item label="時間外移動" prop="jikanGaiIdoJikan" v-show="!isHoliday" :error="errors.jikanGaiIdoJikan">
          <el-input v-model="form.jikanGaiIdoJikan" :disabled="!canEdit || isHoliday" type="time"></el-input>
        </el-form-item>
        <el-form-item label="通勤手当" prop="tsukinTeate">
          <el-select v-model="form.tsukinTeate" :disabled="!canEdit || isTsukinTeateDisabled">
            <el-option v-for="kubun in tsukinTeates" :key="kubun.value" :label="kubun.label" :value="kubun.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交通費" prop="kotsuhi">
          <el-input v-model="form.kotsuhi" :disabled="!canEdit" maxlength="6"></el-input>
        </el-form-item>
        <el-form-item label="リモート" prop="remoteFlag">
          <el-checkbox v-model="form.remoteFlag" :disabled="!canEdit" label="リモート" :border="true"></el-checkbox>
        </el-form-item>
        <el-form-item label="備考" prop="biko">
          <el-autocomplete v-model="form.biko" :disabled="!canEdit" type="textarea" :fetch-suggestions="querySearchBiko" :rows="2" resize="vertical" :maxlength="100"></el-autocomplete>
        </el-form-item>
        <div class="bottom-items">
          <el-button type="primary" :disabled="!canEdit" @click="onRegister('form')">登録</el-button>
          <el-button :disabled="!canEdit || !this.isRegistered" @click="onDelete">削除</el-button>
          <el-button :disabled="!canEdit" @click="onReset">リセット</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { notifySuccess, notifyError } from '../utils.js'

export default {
  name: 'KimmuJissekiK',
  data() {
    return {
      form: {
        shainId: '',
        shainShimei: '',
        kimmuBi: '',
        shigyoJikoku: '',
        shugyoJikoku: '',
        kimmuJikan: '',
        shugyoJikokuHyoji: '',
        chushokuJikan: '',
        kyukeiJikan: '',
        shinyaKyukeiJikanKomi: '',
        shinyaKyukeiJikan: '',
        jikanGaiIdoJikan: '',
        tsukinTeate: 0,
        kotsuhi: 0,
        remoteFlag: '',
        kimmuKubun: '',
        kimmuKubunHosoku: '',
        biko: '',
        zangyoRiyu: '',
        zangyoRiyuAutoCompleteList: [],
        jokyoKubun: '',
        yukyuJikansu: 0,
        yukyuJikanKubun: '',
      },
      errors: {
        kimmuBi: '',
        shigyoJikoku: '',
        shugyoJikoku: '',
        chushokuJikan: '',
        kyukeiJikan: '',
        shinyaKyukeiJikan: '',
        jikanGaiIdoJikan: '',
      },
      yukyuJikanKubuns: [
          {value: '1', label: '始業～'},
          {value: '2', label: '中抜け'},
          {value: '3', label: '～終業'},
      ],
      yukyuJikans: [
          {value: 1, label: '1h'},
          {value: 2, label: '2h'},
          {value: 3, label: '3h'},
          {value: 4, label: '4h'},
          {value: 5, label: '5h'},
          {value: 6, label: '6h'},
          {value: 7, label: '7h'},
      ],
      rules: {
        kimmuBi: [{ required: true, message: '入力してください。' }],
        tsukinTeate: [{ pattern: /^[0-9]*$/, message: '数値を入力してください。' }],
        kotsuhi: [{ pattern: /^[0-9]*$/, message: '数値を入力してください。' }],
      },
      nengetsu: '',
      tsukinTeates: [],
      isTsukinTeateDisabled: false,
      isHoliday: false,
      isRegistered: false,
      isJikanYukyu: false,
      loading: true,
      apiSubPath: '',
    }
  },
  computed: {
    kimmuKubuns() {
      return [
        {value: '11', label: '通常勤務', isHoliday: false},
        {value: '13', label: '休日出勤', isHoliday: false},
        {value: '22', label: '午前半有給', isHoliday: false},
        {value: '23', label: '午後半有給', isHoliday: false},
        {value: '21', label: '全日有給休暇', isHoliday: true},
        {value: '31', label: '時間単位有給', isHoliday: false},
        //{value: '32', label: '外出', isHoliday: false},
        {value: '27', label: '遅刻', isHoliday: false},
        {value: '26', label: '早退', isHoliday: false},
        {value: '28', label: '欠勤', isHoliday: true},
        {value: '33', label: '客先休日(勤務無)', isHoliday: true},
      ];
    },
    canEdit() {
      let kengenKubun = this.$parent.getKengenKubun();
      let jokyoKubun = this.form.jokyoKubun;
      return ((this.form.shainId == this.$parent.getShainId() && (jokyoKubun == '' || jokyoKubun == '11' || jokyoKubun == '12'))
        || (this.form.shainId != this.$parent.getShainId() && kengenKubun >= '700' && (jokyoKubun == '51' || jokyoKubun == '52')));
    },
    isRomu() {
      let kengenKubun = this.$parent.getKengenKubun();
      return (kengenKubun >= '700');
    },
    isRequired() {
      return !this.isHoliday && this.form.kimmuKubun != '22' && this.form.kimmuKubun != '23';
    }
  },
  created() {
    if (location.href.includes('/k/')) {
      this.apiSubPath = '/k';
    }
    if (this.$route.params.kimmuBi === undefined) {
      this.form.kimmuBi = this.$parent.getKimmuBi();
      this.nengetsu = this.$parent.getNengetsu();
    } else {
      this.form.kimmuBi = this.$route.params.kimmuBi;
      this.nengetsu = this.$route.params.nengetsu;
    }
    if (this.$route.params.shainId === undefined) {
      this.form.shainId = null;
    } else {
      this.form.shainId = this.$route.params.shainId;
    }
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      this.$parent.setKimmuBi(this.form.kimmuBi);
      let url = this.apiSubPath + '/gwr/kimmu/kimmuJisseki/' + this.form.kimmuBi;
      if (this.form.shainId != null) {
        url += '/' + this.form.shainId;
      }
      this.$axios.get(url)
          .then((response) => {
            this.form.shainId = response.data.shainId;
            this.form.shainShimei = response.data.shainShimei;
            this.form.shigyoJikoku = response.data.shigyoJikoku;
            this.form.shugyoJikoku = response.data.shugyoJikoku;
            this.form.kimmuJikan = this.diffDate(this.form.shigyoJikoku, this.form.shugyoJikoku);
            this.form.shugyoJikokuHyoji = this.shugyoJikokuHyoji25(this.form.shigyoJikoku, this.form.shugyoJikoku);
            this.form.chushokuJikan = response.data.chushokuJikan;
            this.form.kyukeiJikan = response.data.kyukeiJikan;
            this.form.shinyaKyukeiJikanKomi = response.data.shinyaKyukeiJikan;
            this.form.shinyaKyukeiJikan = response.data.shinyaKyukeiJikan;
            this.form.jikanGaiIdoJikan = response.data.jikanGaiIdoJikan;
            this.form.tsukinTeate = response.data.tsukinTeate;
            this.form.kotsuhi = response.data.kotsuhi;
            this.form.remoteFlag = response.data.remoteFlag;
            this.form.biko = response.data.biko;
            this.form.kimmuKubun = response.data.kimmuKubun;
            this.form.kimmuKubunHosoku = response.data.kimmuKubunHosoku;
            this.form.zangyoRiyu = response.data.zangyoRiyu;
            this.form.jokyoKubun = response.data.jokyoKubun;
            this.form.yukyuJikansu = response.data.yukyuJikansu || 0;
            this.form.yukyuJikanKubun = response.data.yukyuJikanKubun;
            this.isRegistered = response.data.torokuNichiji;
            this.isHoliday = this.kimmuKubuns.find(e => e.value == this.form.kimmuKubun).isHoliday;
            this.isJikanYukyu = (response.data.kimmuKubun == '31');
            this.loading = false;
            this.isTsukinTeateDisabled = !response.data.tsukinTeatePullDown;
            if (response.data.tsukinTeatePullDown != 0) {
              this.tsukinTeates= [
                {value: response.data.tsukinTeatePullDown, label: response.data.tsukinTeatePullDown},
                {value: (response.data.tsukinTeatePullDown/2), label: (response.data.tsukinTeatePullDown/2)},
                '',
              ];
            }
            this.bikoAutoCompleteList = this.loadAutocomplete(response.data.bikoAutoCompleteList);
            this.zangyoRiyuAutoCompleteList = this.loadAutocomplete(response.data.zangyoRiyuAutoCompleteList);
            if (!this.canEdit) {
              this.$notify({
                title: 'この月の業務報告書は提出済みのため、登録・更新ができません。',
                type: 'warning'
              });
              return;
            }
          })
          .catch((error) => {
            notifyError(this, error, 'データ取得エラー', '', true);
          });
    },
    onChange(offset) {
      this.loading = true;
      if (!this.form.kimmuBi) {
        // 勤務日がブランクの場合、後続処理は実行しない。
        this.loading = false;
        return;
      }
      if (offset !== undefined) {
        this.form.kimmuBi = this.$moment(this.form.kimmuBi).add(offset, 'days').format('YYYY-MM-DD');
      }
      this.getData();
    },
    onChangeKubun(e) {
      const val = e.target.value;
      this.isHoliday = this.kimmuKubuns.find(e => e.value == val).isHoliday;
      if (this.isHoliday) {
        this.form.remoteFlag = false;
      }
      this.isJikanYukyu = (val == '31');
      if (this.isJikanYukyu && !this.form.yukyuJikansu) {
        this.form.yukyuJikansu = 1;
        this.form.yukyuJikanKubun = '1';
      }
    },
    onChangeShigyoJikoku() {
      if (!this.form.kimmuJikan) {
        // 勤務時間=NULLの場合、勤務時間を再計算
        this.onChangeShugyoJikoku();
      }
      // 始業時刻に勤務時間を加算した時刻を終業時刻に設定する
      /*
      var shigyoJikoku = this.parseDate(this.form.shigyoJikoku);
      var shugyoJikoku = this.parseDate(this.form.shugyoJikoku);
      var kimmuJikan = this.parseDate(this.form.kimmuJikan);
      shugyoJikoku.setHours(shigyoJikoku.getHours() + kimmuJikan.getHours());
      shugyoJikoku.setMinutes(shigyoJikoku.getMinutes() + kimmuJikan.getMinutes());
      this.form.shugyoJikoku = this.formatDate(shugyoJikoku, "HH:mm");
      */
      // 終業時刻を25時表記にする
      this.form.shugyoJikokuHyoji = this.shugyoJikokuHyoji25(this.form.shigyoJikoku, this.form.shugyoJikoku);
    },
    onChangeShugyoJikoku() {
      // 始業時刻と終業時刻の差分を勤務時間に設定する
      var shigyoJikoku = this.parseDate(this.form.shigyoJikoku);
      var shugyoJikoku = this.parseDate(this.form.shugyoJikoku);
      var kimmuJikan = new Date();
      kimmuJikan.setHours(shugyoJikoku.getHours() - shigyoJikoku.getHours());
      kimmuJikan.setMinutes(shugyoJikoku.getMinutes() - shigyoJikoku.getMinutes());
      this.form.kimmuJikan = this.formatDate(kimmuJikan, 'HH:mm');
      // 終業時刻を25時表記にする
      this.form.shugyoJikokuHyoji = this.shugyoJikokuHyoji25(this.form.shigyoJikoku, this.form.shugyoJikoku);
    },
    onChangeKyuKeiJikan(){
      if (!this.form.kyukeiJikan || !this.form.shinyaKyukeiJikan) {
        return;
      }
      var kyukeiJikan = this.parseDate(this.form.kyukeiJikan);
      var shinyaKyukeiJikan = this.parseDate(this.form.shinyaKyukeiJikan);
      if (kyukeiJikan < shinyaKyukeiJikan) {
        kyukeiJikan = shinyaKyukeiJikan;
      }
      this.form.kyukeiJikan = this.formatDate(kyukeiJikan, "HH:mm");
      this.form.shinyaKyukeiJikanKomi = this.formatDate(shinyaKyukeiJikan, "HH:mm");
    },
    onChangeShinyaKyuKeiJikan(){
      if (!this.form.kyukeiJikan || !this.form.shinyaKyukeiJikan) {
        return;
      }
      var kyukeiJikan = this.parseDate(this.form.kyukeiJikan);
      var shinyaKyukeiJikanKomi = this.parseDate(this.form.shinyaKyukeiJikanKomi);
      var shinyaKyukeiJikan = this.parseDate(this.form.shinyaKyukeiJikan);
      // 変更前の深夜休憩時間を引く
      kyukeiJikan.setHours(kyukeiJikan.getHours() - shinyaKyukeiJikanKomi.getHours());
      kyukeiJikan.setMinutes(kyukeiJikan.getMinutes() - shinyaKyukeiJikanKomi.getMinutes());
      // 変更後の深夜休憩時間を足す
      kyukeiJikan.setHours(kyukeiJikan.getHours() + shinyaKyukeiJikan.getHours());
      kyukeiJikan.setMinutes(kyukeiJikan.getMinutes() + shinyaKyukeiJikan.getMinutes());
      this.form.kyukeiJikan = this.formatDate(kyukeiJikan, "HH:mm");
      this.form.shinyaKyukeiJikanKomi = this.formatDate(shinyaKyukeiJikan, "HH:mm");
    },
    onRegister(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.errors = {
            kimmuBi: '',
            shigyoJikoku: '',
            shugyoJikoku: '',
            chushokuJikan: '',
            kyukeiJikan: '',
            shinyaKyukeiJikan: '',
            jikanGaiIdoJikan: '',
          };
          let hasError = false;
          if (this.isRequired && !this.form.shigyoJikoku) {
            this.errors.shigyoJikoku = '入力してください。';
            hasError = true;
          }
          if (this.isRequired && !this.form.shugyoJikoku) {
            this.errors.shugyoJikoku = '入力してください。';
            hasError = true;
          }
          if (this.isRequired && !this.form.chushokuJikan) {
            this.errors.chushokuJikan = '入力してください。';
            hasError = true;
          }
          if (this.isRequired && !this.form.kyukeiJikan) {
            this.errors.kyukeiJikan = '入力してください。';
            hasError = true;
          }
          if (this.isRequired && !this.form.shinyaKyukeiJikan) {
            this.errors.shinyaKyukeiJikan = '入力してください。';
            hasError = true;
          }
          if (this.isRequired && !this.form.jikanGaiIdoJikan) {
            this.errors.jikanGaiIdoJikan = '入力してください。';
            hasError = true;
          }
          if (hasError) {
            this.$notify({
              title: '入力エラー',
              message: '入力欄に表示されているエラー内容を確認してください。',
              type: 'error'
            });
            return;
          }
          this.loading = true;
          let params = new URLSearchParams(this.form);
          params.set('tsukinTeate', this.form.tsukinTeate ?? '');
          params.set('shigyoJikoku', this.form.shigyoJikoku ?? '');
          params.set('shugyoJikoku', this.form.shugyoJikoku ?? '');
          params.set('kotsuhi', this.form.kotsuhi ?? '');
          params.set('remoteFlag', this.form.remoteFlag ?? false);
          params.set('kimmuKubunHosoku', this.form.kimmuKubunHosoku ?? '');
          params.set('biko', this.form.biko ?? '');
          params.set('zangyoRiyu', this.form.zangyoRiyu ?? '');
          params.set('yukyuJikanKubun', this.form.yukyuJikanKubun ?? '');
          this.$axios.post(this.apiSubPath + '/gwr/kimmu/kimmuJisseki', params)
              .then(() => {
                notifySuccess(this, '登録完了', '勤務実績を登録しました。');
                if (this.form.shainId != this.$parent.getShainId()) {
                  this.$parent.switchMenu('GyomuHokokuK', '/gyomu', { nengetsu: this.nengetsu, shainId: this.form.shainId });
                }
                else if (this.nengetsu != '') {
                  this.$parent.switchMenu('GyomuHokokuK', '/gyomu', { nengetsu: this.nengetsu });
                }
              })
              .catch((error) => {
                notifyError(this, error, '登録エラー', '', true);
              });
        } else {
          return false;
        }
      });
    },
    onDelete() {
      this.loading = true;
      this.$axios.delete(this.apiSubPath + '/gwr/kimmu/kimmuJisseki/' + this.form.kimmuBi + '/' + this.form.shainId)
          .then(() => {
            notifySuccess(this, '削除完了', '勤務実績を削除しました。');
            if (this.form.shainId != this.$parent.getShainId()) {
              this.$parent.switchMenu('GyomuHokokuK', '/gyomu', { nengetsu: this.nengetsu, shainId: this.form.shainId });
            }
            else if (this.nengetsu != '') {
              this.$parent.switchMenu('GyomuHokokuK', '/gyomu', { nengetsu: this.nengetsu });
            }
            else {
              this.getData();
            }
          })
          .catch((error) => {
            notifyError(this, error, '削除エラー', '', true);
          });
    },
    onReset() {
      this.loading = true;
      this.$axios.get(this.apiSubPath + '/gwr/kimmu/kimmuJisseki/' + this.form.kimmuBi + '/' + this.form.shainId + '/reset')
          .then((response) => {
            this.form.shigyoJikoku = response.data.shigyoJikoku;
            this.form.shugyoJikoku = response.data.shugyoJikoku;
            this.form.kimmuJikan = this.diffDate(this.form.shigyoJikoku, this.form.shugyoJikoku);
            this.form.shugyoJikokuHyoji = this.shugyoJikokuHyoji25(this.form.shigyoJikoku, this.form.shugyoJikoku);
            this.form.chushokuJikan = response.data.chushokuJikan;
            this.form.kyukeiJikan = response.data.kyukeiJikan;
            this.form.shinyaKyukeiJikanKomi = response.data.shinyaKyukeiJikan;
            this.form.shinyaKyukeiJikan = response.data.shinyaKyukeiJikan;
            this.form.jikanGaiIdoJikan = response.data.jikanGaiIdoJikan;
            this.form.tsukinTeate = response.data.tsukinTeate;
            this.form.kotsuhi = response.data.kotsuhi;
            this.form.remoteFlag = response.data.remoteFlag;
            this.form.biko = response.data.biko;
            this.form.kimmuKubun = response.data.kimmuKubun;
            this.form.kimmuKubunHosoku = response.data.kimmuKubunHosoku;
            this.form.zangyoRiyu = response.data.zangyoRiyu;
            this.form.yukyuJikansu = response.data.yukyuJikansu || 0;
            this.form.yukyuJikanKubun = response.data.yukyuJikanKubun;
            this.isHoliday = false;
            this.isJikanYukyu = (response.data.kimmuKubun == '31');
            this.loading = false;
            this.isTsukinTeateDisabled = !response.data.tsukinTeatePullDown;
            if (response.data.tsukinTeatePullDown != 0) {
              this.tsukinTeates= [
                {value: response.data.tsukinTeatePullDown, label: response.data.tsukinTeatePullDown},
                {value: (response.data.tsukinTeatePullDown/2), label: (response.data.tsukinTeatePullDown/2)},
                '',
              ];
            }
            this.bikoAutoCompleteList = this.loadAutocomplete(response.data.bikoAutoCompleteList);
            this.zangyoRiyuAutoCompleteList = this.loadAutocomplete(response.data.zangyoRiyuAutoCompleteList);
          })
          .catch((error) => {
            notifyError(this, error, 'データ取得エラー', '', true);
          });
    },
    // date: 日付オブジェクト
    // format: 書式フォーマット
    formatDate (date, format) {
      if (!date) {
        return '';
      }
      format = format.replace(/yyyy/g, date.getFullYear());
      format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
      format = format.replace(/dd/g, ('0' + date.getDate()).slice(-2));
      format = format.replace(/HH/g, ('0' + date.getHours()).slice(-2));
      format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
      format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
      format = format.replace(/SSS/g, ('00' + date.getMilliseconds()).slice(-3));
      return format;
    },
    // dateStr: 時分（HH:mm）を日付型に変換する
    parseDate (dateStr) {
      if (!dateStr) {
        return '';
      }
      var str = dateStr.split(':');
      var date = new Date();
      date.setHours(str[0]);
      date.setMinutes(str[1]);
      date.setSeconds(0);
      return date;
    },
    diffDate (startDate, endDate) {
      if (!startDate || !endDate) {
        return '';
      }
      var date = new Date();
      var sDate = this.parseDate(startDate);
      var eDate = this.parseDate(endDate);
      date.setHours(eDate.getHours() - sDate.getHours());
      date.setMinutes(eDate.getMinutes() - sDate.getMinutes());
      date.setSeconds(0);
      return this.formatDate(date, "HH:mm");
    },
    // 終業時刻を25時表記にする（24時以降の時刻） 
    shugyoJikokuHyoji25 (startDate, endDate) {
      if (!startDate || !endDate 
        || startDate < endDate) {
        document.getElementById('hyoji').style.display = 'none';
        return '';
      }
      var str = endDate.split(':');
      var hour = parseInt(str[0]) + 24;
      document.getElementById('hyoji').style.display = '';
      return hour + ":" + str[1];
    },
    querySearchBiko(queryString, cb) {
      var bikoAutoCompleteList = this.bikoAutoCompleteList;
      // var results = queryString ? bikoAutoCompleteList.filter(this.createFilter(queryString)) : bikoAutoCompleteList; // オートコンプリート
      var results = bikoAutoCompleteList; // 過去の入力履歴をすべて表示
      // call callback function to return suggestions
      cb(results);
    },
    querySearchZangyoRiyu(queryString, cb) {
      var zangyoRiyuAutoCompleteList = this.zangyoRiyuAutoCompleteList;
      // var results = queryString ? zangyoRiyuAutoCompleteList.filter(this.createFilter(queryString)) : zangyoRiyuAutoCompleteList; // オートコンプリート
      var results = zangyoRiyuAutoCompleteList; // 過去の入力履歴をすべて表示
      // call callback function to return suggestions
      cb(results);
    },
    createFilter(queryString) {
      // オートコンプリート用フィルター（未使用）
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    loadAutocomplete(list) {
      var autocompleteList = [];
      for (var i = 0 ;i < list.length; i++) {
        autocompleteList.push({value: list[i]});
      }
      return autocompleteList;
    }
  },
}
</script>

<style scoped>
#kimmuCard {
  width: 340px;
  margin: auto;
}
#kimmuCard >>> .el-card__body {
  padding: 20px 10px 5px 10px !important;
}
.el-form-item {
  text-align: left;
}
.el-input {
  width: 90px !important;
}
.el-autocomplete {
  width: 230px !important;
}
.el-date-editor {
  width: 135px !important;
}
.el-select .el-input {
  width: 100% !important;
}
.el-select {
  width: 130px !important;
}
#kimmuCard >>> #hosoku {
  width: 90px !important;
}
#kimmuCard >>> .el-textarea__inner {
  padding: 5px !important;
  font-size: 14px !important;
  font-family: inherit;
}
#kimmuCard >>> .el-input__inner {
  font-family: inherit;
}
#kimmuCard >>> input[type="time"].el-input__inner {
  width: 130px !important;
}
#shainShimei {
  font-size: 15px;
  font-weight: bold;
}
#kimmuKubunSelect, #yukyuJikanKubunSelect, #yukyuJikanSelect {
  font-family: 'Avenir', Helvetica, Arial, sans-serif, Osaka;
  font-size: 14px;
  height: 36px;
  line-height: 50px;
  color: #606266;
  background-color: #FFFFFF;
  border-color: #DCDFE6;
  border-style: solid;
  border-radius: 4px;
  border-width: 1px;
  padding: 2px;
}
.sub-label {
  padding-left: 45px;
  font-size: 14px;
  color: #606266;
  font-family: 'Avenir', Helvetica, Arial, sans-serif, Osaka;
}
.bottom-items {
  margin-bottom: 22px;
}
.shiftButton {
  width: 42px;
  padding: 10px;
  margin: 0px;
}
</style>
